import moment from 'moment';

export const fileManipulationMixin = {
  data() {
    return {
      defaultFieldsTest: {
        batchFileName: {
          type: 'text',
          required: true,
          autofocus: true,
          label: 'Name',
          name: 'batchFileName',
        },
        entityGuid: {
          type: 'select',
          label: 'Entity',
          required: true,
          name: 'entityGuid',
          data: {
            options: [],
          },
        },
        batchFileType: {
          type: 'select',
          label: 'File Type',
          required: true,
          name: 'batchFileType',
          data: {
            options: [
              {value: null, text: 'Select option please'},
              {value: 'flatFile', text: 'flatFile'},
              {value: 'excel', text: 'excel'},
              {value: 'bulkFlatFile', text: 'bulkFlatFile'},
            ],
          },
        },
        batchFileConfigJSON: {
          type: 'textarea',
          required: false,
          readonly: true,
          label: 'Config JSON',
          name: 'batchFileConfigJSON',
        },
      },
      fileFieldsForExcel: {
        fileNamePattern: {
          type: 'text',
          required: false,
          label: 'File Name Pattern',
          name: 'fileNamePattern',
        },
        useBulkUpload: {
          type: 'checkbox',
          required: false,
          label: 'Use Bulk Upload',
          name: 'useBulkUpload',
        },
      },
      flatFileFieldsForBoth: {
        delimiter: {
          type: 'text',
          required: false,
          label: 'Delimiter',
          name: 'delimiter',
        },
        fileNamePattern: {
          type: 'text',
          required: false,
          label: 'File Name Pattern',
          name: 'fileNamePattern',
        },
        fileNameColumn: {
          type: 'text',
          required: false,
          label: 'File Name Column',
          name: 'fileNameColumn',
        },
        hasHeaderRecord: {
          type: 'checkbox',
          required: false,
          label: 'Has Header Record',
          name: 'hasHeaderRecord',
        },
        ignoreQuotes: {
          type: 'checkbox',
          required: false,
          label: 'Ignore Quotes',
          name: 'ignoreQuotes',
        },
        treatEmptyValuesAsNull: {
          type: 'checkbox',
          required: false,
          label: 'Treat Empty Values As Null',
          name: 'treatEmptyValuesAsNull',
        },
        useColumnPhysicalNames: {
          type: 'checkbox',
          required: false,
          label: 'Use Column Physical Names',
          name: 'useColumnPhysicalNames',
        },
      },
      fieldsForBulk: {
        batchSize: {
          type: 'text',
          required: false,
          label: 'Batch Size',
          name: 'batchSize',
        },
      },
      flatFileExcelFieldsInnerConfig: {
        UploadOperationType: {
          type: 'select',
          required: false,
          label: 'Upload Operation Type',
          name: 'uploadOperationType',
          data: {
            options: [
              {value: 'upsert', text: 'Upsert'},
              {value: 'insert', text: 'Insert'},
              {value: 'update', text: 'Update'},
              {value: 'partialUpdate', text: 'Partial Update'},
            ],
          },
        },
        UploadErrorHandling: {
          type: 'select',
          required: false,
          label: 'Upload Error Handling',
          name: 'uploadErrorHandling',
          data: {
            options: [
              {value: 'failAll', text: 'Fail All'},
              {value: 'rejectRow', text: 'Reject Row'},
            ],
          },
        },//+
        UploadAsAtDate: {
          type: 'datetime',
          required: false,
          readonly: false,
          label: 'Upload As At Date',
          name: 'uploadAsAtDate',
        },
        IgnorePostedStatusUserConstraints: {
          type: 'checkbox',
          required: false,
          label: 'Ignore Posted Status User Constraints',
          name: 'ignorePostedStatusUserConstraints',
        },
        RetrieveOnlyFailedRecords: {
          type: 'checkbox',
          required: false,
          label: 'Retrieve Only Failed Records',
          name: 'retrieveOnlyFailedRecords',
        },
        ValidationOnly: {
          type: 'checkbox',
          required: false,
          label: 'Validation Only',
          name: 'validationOnly',
        },
        DisablePostLoadWorkflow: {
          type: 'checkbox',
          required: false,
          label: 'Disable Post Load Workflow',
          name: 'disablePostLoadWorkflow',
        },
        ForceUpdate: {
          type: 'checkbox',
          required: false,
          label: 'Force Update',
          name: 'forceUpdate',
        },
        AutoConfirmRecordsIfPreviouslyConfirmed: {
          type: 'checkbox',
          required: false,
          label: 'Auto Confirm Records If Previously Confirmed',
          name: 'autoConfirmRecordsIfPreviouslyConfirmed',
        },
        ForceUpdateOfFailedValidationRecords: {
          type: 'checkbox',
          required: false,
          label: 'Force Update Of Failed Validation Records',
          name: 'forceUpdateOfFailedValidationRecords',
        },
      },
      bulkFieldsInnerConfig: {
        implicitDelete: {
          type: 'checkbox',
          required: false,
          label: 'Implicit Delete',
          name: 'implicitDelete',
        },
        expectingAllColumns: {
          type: 'checkbox',
          required: false,
          label: 'Expecting All Columns',
          name: 'expectingAllColumns',
        },
        addMissingColumns: {
          type: 'checkbox',
          required: false,
          label: 'Add Missing Columns',
          name: 'addMissingColumns',
        },
        columnNamesAreDisplayNames: {
          type: 'checkbox',
          required: false,
          label: 'Column Names Are Display Names',
          name: 'columnNamesAreDisplayNames',
        },
        uploadType: {
          type: 'select',
          required: false,
          label: 'Upload Type',
          name: 'uploadType',
          data: {
            options: [
              {value: 'allRecords', text: 'All Records'},
              {value: 'insertsOnly', text: 'Inserts Only'},
              {value: 'updatesOnly', text: 'Updates Only'},
            ],
          },
        },
      },
      addEditBatchModalFields: {
        batchName: {
          type: 'text',
          required: true,
          autofocus: true,
          label: 'Name',
          name: 'batchName',
        },
        waitingDir: {
          type: 'text',
          required: true,
          label: 'Waiting Dir',
          name: 'waitingDir',
        },
        processedDir: {
          type: 'text',
          required: true,
          label: 'Processed Dir',
          name: 'processedDir',
        },
        excepitonDir: {
          type: 'text',
          required: true,
          label: 'Exception Dir',
          name: 'exceptionDir',
        },
        controlFileNamePattern: {
          type: 'text',
          required: false,
          label: 'Control File Name Pattern',
          name: 'controlFileNamePattern',
        },
        controlFileDelimiter: {
          type: 'text',
          required: false,
          label: 'Control File Delimiter',
          name: 'controlFileDelimiter',
        },
        emailRecipientsOnSuccess: {
          type: 'text',
          required: false,
          label: 'Email Recipients On Success',
          name: 'emailRecipientsOnSuccess',
        },
        emailRecipientsOnFailure: {
          type: 'text',
          required: false,
          label: 'Email Recipients On Failure',
          name: 'emailRecipientsOnFailure',
        },
        emailRecipientsOnCompletion: {
          type: 'text',
          required: false,
          label: 'Email Recipients On Completion',
          name: 'emailRecipientsOnCompletion',
        },
        emailNotificationFrom: {
          type: 'text',
          required: false,
          label: 'Email Notification From',
          name: 'emailNotificationFrom',
        },
      },
    };
  },
  methods: {
    setDefaultValue(val, defaultValue) {
      return this.isEditMode ? val : defaultValue;
    },
    generateExcelFileConfig() {
      const config = this.batchFile.batchFileConfig;
      const res = {
        ...this.formFromStore,
        useBulkUpload: this.setDefaultValue(config?.useBulkUpload, false),
        fileNamePattern: this.setDefaultValue(config?.fileNamePattern, null),
        batchSize: this.setDefaultValue(config?.batchSize, null),
        sheetConfigs: this.setDefaultValue(config?.config.sheetConfigs, []),

        bulkInnerConfig: {
          addMissingColumns: this.setDefaultValue(
            config?.uploadBulkRecordConfig?.addMissingColumns,
            false,
          ),
          partitions: this.setDefaultValue(
            config?.uploadBulkRecordConfig?.partitions,
            {},
          ),
          columnNamesAreDisplayNames: this.setDefaultValue(
            config?.uploadBulkRecordConfig?.columnNamesAreDisplayNames,
            false,
          ),
          expectingAllColumns: this.setDefaultValue(
            config?.uploadBulkRecordConfig?.expectingAllColumns,
            false,
          ),
          implicitDelete: this.setDefaultValue(
            config?.uploadBulkRecordConfig?.implicitDelete,
            false,
          ),
          uploadType: this.setDefaultValue(
            config?.uploadBulkRecordConfig?.uploadType,
            'allRecords',
          ),
        },

        innerConfig: {
          addEmptyColumns: this.setDefaultValue(
            config?.uploadRecordConfig?.addEmptyColumns,
            [],
          ),
          columnMappings: this.setDefaultValue(
            config?.uploadRecordConfig?.columnMappings,
            [],
          ),
          calculatedColumns: this.setDefaultValue(
            config?.uploadRecordConfig?.calculatedColumns,
            [],
          ),
          inheritValueFromExistingRecord: this.setDefaultValue(
            config?.uploadRecordConfig?.inheritValueFromExistingRecord,
            [],
          ),
          lookups: this.setDefaultValue(
            config?.uploadRecordConfig?.lookups,
            [],
          ),
          validationRulesToSkip: this.setDefaultValue(
            config?.uploadRecordConfig?.validationRulesToSkip,
            [],
          ),

          autoConfirmRecordsIfPreviouslyConfirmed: this.setDefaultValue(
            config?.uploadRecordConfig?.autoConfirmRecordsIfPreviouslyConfirmed,
            false,
          ),
          disablePostLoadWorkflow: this.setDefaultValue(
            config?.uploadRecordConfig?.disablePostLoadWorkflow,
            false,
          ),
          forceUpdate: this.setDefaultValue(config?.uploadRecordConfig?.forceUpdate, false),
          forceUpdateOfFailedValidationRecords: this.setDefaultValue(
            config?.uploadRecordConfig?.forceUpdateOfFailedValidationRecords,
            false,
          ),
          ignorePostedStatusUserConstraints: this.setDefaultValue(
            config?.uploadRecordConfig?.ignorePostedStatusUserConstraints,
            false,
          ),
          retrieveOnlyFailedRecords: this.setDefaultValue(
            config?.uploadRecordConfig?.retrieveOnlyFailedRecords,
            false,
          ),
          uploadAsAtDate: this.setDefaultValue(
            moment(config?.uploadRecordConfig?.uploadAsAtDate).toDate('YYYY-MM-DD HH:mm:ss'),
            null,
          ),
          uploadOperationType: this.setDefaultValue(
            config?.uploadRecordConfig?.uploadOperationType,
            'upsert',
          ),
          uploadErrorHandling: this.setDefaultValue(
            config?.uploadRecordConfig?.uploadErrorHandling,
            'failAll',
          ),
          validationOnly: this.setDefaultValue(
            config?.uploadRecordConfig?.validationOnly,
            false,
          ),
        },
      };
      this.updateFormInStore(res);
    },
    generateBulkFlatFileConfig(flatFilesConfig) {
      const config = this.batchFile.batchFileConfig;
      const res = {
        ...this.formFromStore,
        ...flatFilesConfig,
        batchSize: this.setDefaultValue(config?.batchSize, null),
        transform: this.setDefaultValue(config?.transform, []),
        valuesToTreatAsNull: this.setDefaultValue(config?.valuesToTreatAsNull, []),
        innerConfig: {
          addMissingColumns: this.setDefaultValue(
            config?.uploadRecordConfig?.addMissingColumns,
            false,
          ),
          partitions: this.setDefaultValue(config?.uploadRecordConfig?.partitions, {}),

          columnNamesAreDisplayNames: this.setDefaultValue(
            config?.uploadRecordConfig.columnNamesAreDisplayNames,
            false,
          ),
          fileNamePattern: this.setDefaultValue(
            config?.uploadRecordConfig.expectingAllColumns,
            false,
          ),
          expectingAllColumns: this.setDefaultValue(
            config?.uploadRecordConfig.expectingAllColumns,
            false,
          ),
          implicitDelete: this.setDefaultValue(
            config?.uploadRecordConfig.implicitDelete,
            false,
          ),
          uploadType: this.setDefaultValue(
            config?.uploadRecordConfig.uploadType,
            'allRecords',
          ),
        },
      };
      this.updateFormInStore(res);
    },
    generateFlatFileConfig(flatFilesConfig) {
      const config = this.batchFile.batchFileConfig?.uploadRecordConfig;
      const res = {
        ...this.formFromStore,
        ...flatFilesConfig,
        transforms: this.setDefaultValue(
          this.batchFile?.batchFileConfig?.transforms,
          [],
        ),
        valuesToTreatAsNull: this.setDefaultValue(
          this.batchFile?.batchFileConfig?.valuesToTreatAsNull,
          [],
        ),
        innerConfig: {
          autoConfirmRecordsIfPreviouslyConfirmed: this.setDefaultValue(
            config?.autoConfirmRecordsIfPreviouslyConfirmed,
            false,
          ),
          disablePostLoadWorkflow: this.setDefaultValue(config?.disablePostLoadWorkflow, false),

          addEmptyColumns: this.setDefaultValue(config?.addEmptyColumns, []),//+
          calculatedColumns: this.setDefaultValue(config?.calculatedColumns, []),//+
          columnMappings: this.setDefaultValue(config?.columnMappings, []),//+
          inheritValueFromExistingRecord: this.setDefaultValue(
            config?.inheritValueFromExistingRecord,
            [],
          ),//+
          lookups: this.setDefaultValue(config?.lookups, []),//+
          validationRulesToSkip: this.setDefaultValue(config?.validationRulesToSkip, []),//+

          forceUpdate: this.setDefaultValue(config?.forceUpdate, false),
          forceUpdateOfFailedValidationRecords: this.setDefaultValue(
            config?.forceUpdateOfFailedValidationRecords,
            false,
          ),
          ignorePostedStatusUserConstraints: this.setDefaultValue(
            config?.ignorePostedStatusUserConstraints,
            false,
          ),
          retrieveOnlyFailedRecords: this.setDefaultValue(
            config?.retrieveOnlyFailedRecords,
            false,
          ),
          uploadAsAtDate: this.setDefaultValue(
            moment(config?.uploadAsAtDate).toDate('YYYY-MM-DD HH:mm:ss'),
            null,
          ),
          uploadOperationType: this.setDefaultValue(config?.uploadOperationType, 'upsert'),
          uploadErrorHandling: this.setDefaultValue(config?.uploadErrorHandling, 'failAll'),
          validationOnly: this.setDefaultValue(config?.validationOnly, false),
        },
      };
      this.updateFormInStore(res);
    },
    collectAddEditBatchFileModalFormInEditMode() {
      const batchFile = this.batchFile;
      const isExcelFileType = this.formFromStore.batchFileType === 'excel' || batchFile.batchFileType === 'excel';

      const isBulkFlatFileType = batchFile.batchFileType === 'bulkFlatFile'
                || this.formFromStore.batchFileType === 'bulkFlatFile';
      const isFlatFileType = batchFile.batchFileType === 'flatFile'
                || this.formFromStore.batchFileType === 'flatFile';


      const batchFileConfig = batchFile?.batchFileConfig;
      const flatFilesConfig = {
        delimiter: this.setDefaultValue(batchFileConfig?.delimiter, null),
        fileNamePattern: this.setDefaultValue(batchFileConfig?.fileNamePattern, null),
        fileNameColumn: this.setDefaultValue(batchFileConfig?.fileNameColumn, null),
        hasHeaderRecord: this.setDefaultValue(batchFileConfig?.hasHeaderRecord, false),
        ignoreQuotes: this.setDefaultValue(batchFileConfig?.ignoreQuotes, false),
        treatEmptyValuesAsNull: this.setDefaultValue(batchFileConfig?.treatEmptyValuesAsNull, false),
        useColumnPhysicalNames: this.setDefaultValue(batchFileConfig?.useColumnPhysicalNames, false),
      };

      const res = {
        batchFileName: this.setDefaultValue(batchFile?.batchFileName, this.formFromStore.batchFileName || null),
        entityGuid: this.setDefaultValue(
          {value: batchFile.enitiyGuid, text: this.tablesList[batchFile.enitiyGuid]?.label},
          this.formFromStore.entityGuid || {value: null, text: ''},
        ),
        batchFileType: this.setDefaultValue(batchFile?.batchFileType, this.formFromStore.batchFileType || null),
        dependencyGroup: this.setDefaultValue(batchFile?.dependencyGroup, null),
      };

      this.updateFormInStore(res);
      if (isExcelFileType) {
        this.generateExcelFileConfig();
      } else if (isFlatFileType) {
        this.generateFlatFileConfig(flatFilesConfig);
      } else if (isBulkFlatFileType) {
        this.generateBulkFlatFileConfig(flatFilesConfig);
      }
    },
  },
};